module.exports = __webpack_public_path__ + "img/new.2cb3c80e.svg";